import { PageBlueprint } from '@backstage/frontend-plugin-api';
import { CatalogIndexPage } from '@backstage/plugin-catalog/alpha';

export const catalogUsersPage = PageBlueprint.make({
  name: 'catalog-users',
  params: {
    path: '/catalog/users',
    title: 'Users',
    loader: async () => (
      <CatalogIndexPage initialKind="user" initiallySelectedFilter="all" />
    ),
  },
});

export const catalogGroupsPage = PageBlueprint.make({
  name: 'catalog-groups',
  params: {
    path: '/catalog/groups',
    title: 'Groups',
    loader: async () => (
      <CatalogIndexPage initialKind="group" initiallySelectedFilter="all" />
    ),
  },
});
